import { render } from "./PageSearch.vue?vue&type=template&id=67bdf6a0&lang=html"
import script from "./PageSearch.vue?vue&type=script&lang=js"
export * from "./PageSearch.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__